import { render, staticRenderFns } from "./IssueFiles.vue?vue&type=template&id=1cc3a443&scoped=true&"
import script from "./IssueFiles.vue?vue&type=script&lang=js&"
export * from "./IssueFiles.vue?vue&type=script&lang=js&"
import style0 from "./IssueFiles.vue?vue&type=style&index=0&id=1cc3a443&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc3a443",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VContainer,VDialog,VFlex,VIcon,VLayout,VProgressCircular})
